import actions from "./actions";

const initState = {
  account: {},
};

export default function reducer(state = initState, { type, ...action }) {
  switch (type) {
    case actions.REGISTER_SUCCESS:
      return {
        ...state,
        account: action.user,
      };

    default:
      return state;
  }
}
